import React from 'react';
import {BrowserRouter as Router, Route,  Switch} from 'react-router-dom';
 
import '../css/App.css';
// import Header from './Header';
// import Productos from './Productos';
// import Fooder from './Fooder';
// import Suscribirse from './Suscribirse';
// import Mapa from './Mapa';
// import Banner from './Banner';
// import Conocenos from './Conocenos';
// import Contactenos from './Contactenos';
// import Marca from './Marca';
// import Promesa from './Promesa';
import Alfombras  from './Alfombras';
function App() {

 
  return (
    <Router>
    <main>
      <Switch>
      <Alfombras/>
      </Switch>   
          {/** <Header/> 
        <Productos/>
        <Marca/>
        <Promesa/>
        <Banner/>
        <Conocenos/>
        <Mapa/>
        <Contactenos/>
        <Suscribirse/>
        <Fooder/>   */}   
    </main>     
        
   </Router>
  );
}

export default App;
